'use client'

import { useEffect } from 'react'

const COOKIE = 'll_source'
const MAX_AGE = 60 * 60 * 24 * 90

function readCookie() {
  return document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${COOKIE}=`))
    ?.slice(COOKIE.length + 1) ?? ''
}

function writeCookie(value: string) {
  document.cookie = `${COOKIE}=${encodeURIComponent(value)}; path=/; max-age=${MAX_AGE}; samesite=lax`
}

function detectSource(search: string) {
  const params = new URLSearchParams(search)
  const gclid = params.get('gclid') || params.get('wbraid') || params.get('gbraid')
  const fbclid = params.get('fbclid')
  const source = params.get('utm_source') || (gclid ? 'google' : '') || (fbclid ? 'meta' : '')
  if (!source) return ''
  const medium = params.get('utm_medium')
    || (gclid ? 'cpc' : '')
    || (fbclid ? 'paid_social' : '')
  const campaign = params.get('utm_campaign') || ''
  return [source, medium, campaign].filter(Boolean).join(' / ').slice(0, 120)
}

/**
 * Mémorise la provenance publicitaire dès la première visite concernée.
 *
 * La première source connue est conservée (attribution au premier contact) :
 * une visite ultérieure directe n'écrase pas la campagne qui a fait venir la
 * personne. Aucune donnée n'est envoyée à un tiers, le cookie reste interne.
 */
export default function AdSourceTracker() {
  useEffect(() => {
    try {
      if (readCookie()) return
      const source = detectSource(window.location.search)
      if (source) writeCookie(source)
    } catch {
      // Un stockage indisponible ne doit jamais gêner la navigation.
    }
  }, [])

  return null
}